/**
* Card List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'card-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth > 640 ) {
        gsap.to( '.cards_left', {
          translateY: '160px',
          ease: 'none',
          scrollTrigger: {
            trigger: '.card-list',
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
          },
        } );

        gsap.to( '.cards_right', {
          translateY: '-160px',
          ease: 'none',
          scrollTrigger: {
            trigger: '.card-list',
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
          },
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-list', COMPONENT );
} )( app );
